import React, { useState } from "react";
import Registries from "../../views/registries";

export default function CriticalityTable(props) {
  return <Registries {...props} highCriticality />;
}
